const initialState = {};

const routes = (state = initialState, action) => {
	switch (action.type) {
		default: {
			return state;
		}
	}
};

export default routes;
